/*
 * @Author: gaobin
 * @Date: 2025-06-20 13:56:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-08 14:43:44
 * @Description: 公用的
 */
const globalMap = {
  // 查询当前商品集合（单个or多个）存在优惠券列表
  getCurrentProductCouponListExt: '/usb/api/v1/coupon/user/available/by-products',
  // 查询可用优惠券列表
  getAvailableCouponListExt: '/usb/api/v1/coupon/user/available',
  // 领取优惠券
  receiveCoupon: '/api/v1/coupon/user/receive',
};

export default globalMap;
